import {t} from '@lingui/core/macro';

import {DomainIncidentType} from 'features/domain/model/DomainIncident/IDomainIncident';
import IDomainIncidentFilters from 'features/domain/model/DomainIncident/IDomainIncidentFilters';
import {IDomainIncidentsFiltersForm} from 'features/domain/model/DomainIncident/IDomainIncidentsFiltersForm';
import {ALL_FILTER_VALUE} from 'shared/lib/filterHelper';

import {translateDomainIncidentCause} from './domainIncidentHelper';

export const SEARCHABLE_FROM_OPTIONS_COUNT = 5;

export const FILTERABLE_DOMAIN_INCIDENT_TYPES: DomainIncidentType[] = [
    'ssl-expired',
    'ssl-redirect-missing',
    'domain-expired',
    'robots-txt-missing',
    'robots-txt-restricted',
    'robots-txt-home-disallowed',
    'robots-txt-site-map-not-specified',
    'rkn-block',
];

interface IDomainMonitorOptionSource {
    uuid: string,
    domain_human_readable: string,
}

export function buildDomainMonitorOptions(items: IDomainMonitorOptionSource[] | undefined) {
    return [
        {value: ALL_FILTER_VALUE, label: t`Все мониторы доменов`},
        ...(items ?? []).map(item => ({
            value: item.uuid,
            label: item.domain_human_readable,
        })),
    ];
}

export function buildDomainIncidentTypeOptions() {
    return FILTERABLE_DOMAIN_INCIDENT_TYPES.map(type => ({
        id: type,
        value: type,
        label: translateDomainIncidentCause(type),
    }));
}

export function getDomainIncidentsFiltersDefaults(
    filters: IDomainIncidentFilters,
): Pick<IDomainIncidentsFiltersForm, 'type' | 'domainMonitor'> {
    return {
        type: ((filters as {type?: string[]}).type ?? []).filter(value => value.trim() !== ''),
        domainMonitor: filters['domain_monitor.uuid'] ?? ALL_FILTER_VALUE,
    };
}
